var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCookieBlock && _vm.cont && _vm.cont.title
    ? _c("div", { staticClass: "page-cookies" }, [
        _c("div", { staticClass: "page-cookies__text" }, [
          _c("h3", [_vm._v(_vm._s(_vm.cont.title))]),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.cont.text) } })
        ]),
        _c(
          "a",
          {
            staticClass: "page-cookies__allow-button",
            attrs: { id: "cookies__allow-button" },
            on: {
              click: function($event) {
                _vm.setConfirmCookies()
              }
            }
          },
          [_vm._v("Разрешить")]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d3d043a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3d043a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/footer/CookieConfirm.vue
// module id = r1dJ
// module chunks = 41